import React from 'react';

import { withEventScope } from '@repo/event-processor';
import { Button, secondaryTheme } from '@repo/ui/components/Buttons';
import { Spacer } from '@repo/ui/components/Spacer';

import {
  ResponsiveHeader,
  ResponsiveText,
  ResponsiveButtonsWrapper,
} from '../styles';

import RoadmapGraphic from './assets/RoadmapGraphic';
import { RoadmapContentProps } from './types';

const RoadmapContent: React.FC<RoadmapContentProps> = ({
  heading,
  subheading,
  icon,
  primaryButton,
  secondaryButton,
}) => {
  return (
    <>
      {icon}
      <Spacer height="12px" />
      <ResponsiveHeader>{heading}</ResponsiveHeader>
      {subheading && (
        <>
          <Spacer height="12px" />
          <ResponsiveText>{subheading}</ResponsiveText>
        </>
      )}
      <Spacer height="12px" />
      <ResponsiveText>
        We are working on some exciting new features, so stay tuned!
      </ResponsiveText>
      <Spacer height="24px" />
      <RoadmapGraphic />
      <Spacer height="24px" />
      <ResponsiveButtonsWrapper>
        {secondaryButton && (
          <Button
            label={secondaryButton.label}
            name="cancelOffboardingButton"
            theme={secondaryTheme}
            width="100%"
            onClick={secondaryButton.onClick}
          />
        )}

        <Button
          label={primaryButton.label}
          name="confirmOffboardingButton"
          width="100%"
          onClick={primaryButton.onClick}
        />
      </ResponsiveButtonsWrapper>
    </>
  );
};

export default withEventScope(RoadmapContent, { module: 'roadmapContent' });
